import { type CartDrawer } from '@/scripts/cart/cart-drawer'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { ATTRIBUTES, PUB_SUB_EVENTS, publish } from '@/scripts/core/global'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {type PdpUpsellModal} from "@/scripts/cart/pdp-upsell-modal";

export class UpsellForm extends UcoastEl {
	static htmlSelector = 'upsell-form'
	submitButton: HTMLButtonElement
	variantSelectors: NodeListOf<HTMLButtonElement>
	variantImages: NodeListOf<HTMLElement>
	colorNameEl: HTMLElement
	mainCTATextEl: HTMLElement
	soldOutCTATextEl: HTMLElement
	upsellFromVariant: string
	cart: CartDrawer
	currentVariantId: number
	sellingPlanID?: number
	modal?: PdpUpsellModal
	constructor() {
		super()
		if (this.hasAttribute('data-redirect-from-modal')) {
      this.modal = q.os<PdpUpsellModal>('pdp-upsell-modal')
    }
		const currentVariantIDStr = q.ra(this, 'data-variant-id')
		const sellingPlanIDStr = q.oa(this, 'data-selling-plan-id')
		this.variantImages = q.rl('[data-upsell-image-variant]', this)
		this.currentVariantId = parseInt(currentVariantIDStr)
		this.sellingPlanID = sellingPlanIDStr
			? parseInt(sellingPlanIDStr)
			: undefined
		this.submitButton = q.rs('button[data-submit]', this)
		this.colorNameEl = q.rs('[data-color-name-el]', this)
		this.mainCTATextEl = q.rs('[data-main-cta-text]', this)
		this.soldOutCTATextEl = q.rs('[data-sold-out-cta-text]', this)
		this.variantSelectors = q.rl('button[data-variant-id]', this)
		this.upsellFromVariant = q.ra(this, 'data-upsell-from-variant')
		this.cart = q.rs<CartDrawer>('cart-drawer')
		this.variantSelectors.forEach((el) => {
			el.addEventListener('click', this.onVariantSelect.bind(this))
		})
		this.submitButton.addEventListener('click', this.add.bind(this))
	}
	onVariantSelect(e: MouseEvent) {
		e.preventDefault()
		const target = q.rct(e)
		const variantId = q.ra(target, 'data-variant-id')
		const colorName = q.ra(target, 'data-color-name')
		this.colorNameEl.textContent = colorName
		this.variantSelectors.forEach((el) => {
			if (el.getAttribute('data-variant-id') === variantId) {
				el.classList.add('active')
			} else {
				el.classList.remove('active')
			}
		})
		this.variantImages.forEach((el) => {
			if (el.getAttribute('data-upsell-image-variant') === variantId) {
				el.classList.add('active')
			} else {
				el.classList.remove('active')
			}
		})
		const active = target.getAttribute('data-available')
		if (active !== 'true') {
			this.submitButton.setAttribute('disabled', '')
			this.mainCTATextEl.classList.add('hidden')
			this.soldOutCTATextEl.classList.remove('hidden')
		} else {
			this.submitButton.removeAttribute('disabled')
			this.mainCTATextEl.classList.remove('hidden')
			this.soldOutCTATextEl.classList.add('hidden')
		}
		this.currentVariantId = parseInt(variantId)
	}
	add(e: MouseEvent) {
		e.preventDefault()
		const item = this.sellingPlanID
			? {
					selling_plan: this.sellingPlanID,
					id: this.currentVariantId,
					quantity: 1,
					properties: {
						_upsell_from_variant: parseInt(this.upsellFromVariant),
					},
				}
			: {
					id: this.currentVariantId,
					quantity: 1,
					properties: {
						_upsell_from_variant: parseInt(this.upsellFromVariant),
					},
				}
        // close modal on submit

    this.modal?.hide()
		fetch(`${window.routes.cart_add_url}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: `application/json`,
				'X-Requested-With': 'XMLHttpRequest',
			},
			body: JSON.stringify({
				items: [item],
				sections: ['cart-drawer', 'cart-icon-bubble'],
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				if (response.status || response.errors) {
					publish(PUB_SUB_EVENTS.cartError, response)
					return
				}
				publish(PUB_SUB_EVENTS.cartError, {
					source: 'product-form',
					productVariantId: `${this.currentVariantId}`,
					errors: response.errors || response.description,
					message: response.message,
				})
        if (this.modal) {
          this.cart.open(this.modal.opener)
        }
				this.cart.renderContents(response)
			})
			.catch((e) => {
				console.error(e)
			})
			.finally(() => {
				this.submitButton.removeAttribute(ATTRIBUTES.loading)
				this.cart?.hasAttribute(ATTRIBUTES.cartEmpty) &&
					this.cart.removeAttribute(ATTRIBUTES.cartEmpty)
			})
	}
}
